module.exports = __webpack_public_path__ + "img/suit-2.d5ddfb28.jpg";